var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{
    'light': _vm.variant === 'light',
    'primary': _vm.variant === 'primary',
    'secondary': _vm.variant === 'secondary',
    'disabled': _vm.disabled
  },attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":_vm.onClickButton}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }